import $ from "jquery";

export function init() {
  // @ts-ignore
  $("#cocalc-react-crash").processIcons?.();
}
